<template>
  <div class="app-psi-container">
    <!-- 视图一：登录页 -->
    <div class="login-view" v-if="!isLoggedIn">
      <div class="login-header">
        <div class="logo-box">
          <span>阵</span>
        </div>
        <h1 class="title">九阵数字云诊所</h1>
        <p class="subtitle">简易出入库 手机版</p>
      </div>

      <div class="login-form">
        <!-- 账号不可更改，从本地存储读取 -->
        <el-input
          v-model="loginForm.username"
          placeholder="账号"
          prefix-icon="el-icon-user"
          disabled
          class="custom-input"
        ></el-input>
        
        <el-input
          v-model="loginForm.password"
          type="password"
          placeholder="密码"
          prefix-icon="el-icon-lock"
          show-password
          class="custom-input"
          @keyup.enter.native="handleLogin"
        ></el-input>

        <div class="remember-box">
          <el-checkbox v-model="loginForm.rememberMe">记住登录状态</el-checkbox>
        </div>

        <el-button 
          type="primary" 
          class="login-btn" 
          :loading="loginLoading" 
          @click="handleLogin"
        >
          登 录
        </el-button>
      </div>

      <div class="login-footer">
        用诊所现有账号登录，登一次即记住登录态<br/>
        之后点桌面图标直接进功能菜单，不用再输账号密码
      </div>
    </div>

    <!-- 视图二：功能菜单主页 -->
    <div class="main-view" v-else>
      <!-- 顶部导航 -->
      <div class="header">
        <div class="header-left">
          <i class="el-icon-menu"></i>
          <div class="header-title">
            <span>功能菜单</span>
            <span class="sub-title">示范诊所·药房</span>
          </div>
        </div>
        <div class="header-right" @click="handleLogout">退出登录</div>
      </div>

      <!-- 可滚动主体内容 -->
      <div class="scroll-content">
        <!-- 四宫格菜单 -->
        <div class="menu-grid">
          <!-- 药品信息 -->
          <div class="menu-card">
            <div class="card-title">
              <i class="el-icon-s-grid" style="color: #409EFF;"></i>
              <span>药品信息</span>
            </div>
            <div class="card-list">
              <div class="list-item"><span>商品目录</span><span class="desc">维护·新增</span></div>
              <div class="list-item"><span>药品建档</span><span class="desc">扫码·手工</span></div>
              <div class="list-item"><span>库存查询</span><span class="desc">余量·效期</span></div>
            </div>
          </div>

          <!-- 入库单 -->
          <div class="menu-card">
            <div class="card-title">
              <i class="el-icon-box" style="color: #67C23A;"></i>
              <span>入库单</span>
            </div>
            <div class="card-list">
              <div class="list-item"><span>入库单记录</span><span class="desc">今日采购入库单</span></div>
              <div class="list-item"><span>+ 新增入库单</span><span class="desc">开单用扫码</span></div>
            </div>
          </div>

          <!-- 出库单 -->
          <div class="menu-card">
            <div class="card-title">
              <i class="el-icon-sell" style="color: #E6A23C;"></i>
              <span>出库单</span>
            </div>
            <div class="card-list">
              <div class="list-item"><span>出库单记录</span><span class="desc">今日销售出库单</span></div>
              <div class="list-item"><span>+ 新增出库单</span><span class="desc">开单用扫码</span></div>
            </div>
          </div>

          <!-- 相关报表 -->
          <div class="menu-card">
            <div class="card-title">
              <i class="el-icon-data-line" style="color: #909399;"></i>
              <span>相关报表</span>
            </div>
            <div class="card-list">
              <div class="list-item"><span>库存报表</span><span class="desc">余量与金额</span></div>
              <div class="list-item"><span>入库汇总</span><span class="desc">进销明细</span></div>
              <div class="list-item"><span>销售汇总</span><span class="desc">金额与毛利</span></div>
              <div class="list-item"><span>追溯码上报</span><span class="desc">上报状态</span></div>
            </div>
          </div>
        </div>

        <!-- 数据统计模块 -->
        <div class="stats-bar">
          <div class="stat-item">
            <div class="num">10</div>
            <div class="label">今日入库</div>
          </div>
          <div class="stat-item">
            <div class="num">1</div>
            <div class="label">今日销售</div>
          </div>
          <div class="stat-item">
            <div class="num">5</div>
            <div class="label">库存品种</div>
          </div>
          <div class="stat-item">
            <div class="num">3</div>
            <div class="label">报损</div>
          </div>
        </div>

        <!-- 今日动态 -->
        <div class="dynamic-card">
          <div class="dynamic-header">
            <span class="title">今日动态</span>
            <span class="sort">按时间倒序</span>
          </div>
          <div class="dynamic-list">
            <div class="dynamic-item" v-for="(item, index) in dynamicList" :key="index">
              <span class="time">{{ item.time }}</span>
              <span class="action">{{ item.action }}</span>
              <span class="name">{{ item.name }}</span>
              <span class="qty" :class="item.type">{{ item.qty }}</span>
            </div>
          </div>
        </div>

        <!-- 底部提示文案 -->
        <div class="tips-box">
          四块功能就这些：药品信息管档案和库存，入库单管进药，出库单管卖药，相关报表看一段时间的结果。
        </div>
      </div>

      <!-- 底部固定操作按钮 -->
      <div class="bottom-actions">
        <button class="btn btn-blue">+ 新增入库单</button>
        <button class="btn btn-green">+ 新增出库单</button>
      </div>
    </div>
  </div>
</template>

<script>
// 引入登录接口
import { login } from "@/api/user.js";

export default {
  name: 'AppPsi',
  data() {
    return {
      isLoggedIn: false,
      loginLoading: false,
      loginForm: {
        username: '', // 初始为空，由 created 从本地存储获取
        password: '',
        rememberMe: true
      },
      // 模拟今日动态数据
      dynamicList: [
        { time: '09:12', action: '入库', name: '阿莫西林胶囊 ×10', qty: '+10', type: 'in' },
        { time: '10:40', action: '销售', name: '布洛芬混悬液 ×2', qty: '-2', type: 'out' }
      ]
    }
  },
  created() {
    this.getUserInfoFromStorage();
  },
  methods: {
    // 获取本地存储的用户信息
    getUserInfoFromStorage() {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          // 兼容 username 和 userName
          if (userInfo && (userInfo.username || userInfo.userName)) {
            this.loginForm.username = userInfo.username || userInfo.userName;
          }
        } catch (e) {
          console.error('解析本地 userInfo 失败', e);
        }
      } else {
        console.warn('本地存储中未找到 userInfo');
      }
    },
    
    // 处理登录逻辑
    async handleLogin() {
      if (!this.loginForm.password) {
        this.$message.warning('请输入密码');
        return;
      }
      if (!this.loginForm.username) {
        this.$message.error('账号信息缺失，请重新登录获取');
        return;
      }

      this.loginLoading = true;
      try {
        // 参考 Login.vue 组装完整的请求参数
        const payload = {
          userName: this.loginForm.username, // 注意接口参数名为 userName
          password: this.loginForm.password,
          docDeviceInfoVO: {
            browser: navigator.vendor,
            localIp: process.env.VUE_APP_HOST || '', // 对应 Login.vue 中的 this.ip
            machineId: process.env.VUE_APP_MACHINEID || '', // 对应 Login.vue 中的 this.machineId
            os: navigator.userAgent.slice(13, 13 + 27)
          }
        };

        const res = await login(payload);

        // 严格判断接口返回的 code === 200
        if (res.code === 200) {
          this.$message.success('登录成功');
          
          // 保存相关登录信息（参考 Login.vue 逻辑）
          if (res.data) {
            if (res.data.token) {
              localStorage.setItem('token', res.data.token);
            }
            if (res.data.user) {
              localStorage.setItem('userInfo', JSON.stringify(res.data.user));
            }
            if (res.data.terminalId) {
              localStorage.setItem('terminalId', JSON.stringify(res.data.terminalId));
            }
            if (res.data.permissions) {
              localStorage.setItem('permissions', JSON.stringify(res.data.permissions));
            }
            if (res.data.roles && res.data.roles.length > 0) {
              localStorage.setItem('userRoles', JSON.stringify(res.data.roles));
            }
          }

          // 修改当前组件状态以显示菜单内容
          this.isLoggedIn = true;

          // 跳转至路由 /AppPsi 
          if (this.$route.path !== '/AppPsi') {
            this.$router.push('/AppPsi');
          }
        } else {
          // code 不是 200，提示后端返回的错误信息
          this.$message.error(res.message || '登录失败，请检查账号密码');
        }
      } catch (error) {
        this.$message.error(error.message || '登录请求异常');
      } finally {
        this.loginLoading = false;
      }
    },

    // 退出登录
    handleLogout() {
      this.isLoggedIn = false;
      this.loginForm.password = ''; // 退出时清空密码
      localStorage.removeItem('token');
      this.$message.info('已退出登录');
    }
  }
}
</script>

<style lang="less" scoped>
/* ================= 基础容器适配 ================= */
.app-psi-container {
  width: 100vw;
  height: 100vh; /* 适配手机端全屏 */
  margin: 0 auto;
  background-color: #f4f6f8;
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  overflow: hidden;
}

/* PC 端居中模拟手机效果（当屏幕宽度大于 480px 时生效） */
@media (min-width: 480px) {
  .app-psi-container {
    max-width: 400px;
    height: 100vh; 
    box-shadow: 0 0 20px rgba(0,0,0,0.1);
  }
}

/* ================= 登录页样式 ================= */
.login-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 30px;
  background-color: #ffffff;

  .login-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;

    .logo-box {
      width: 60px;
      height: 60px;
      background-color: #3b82f6;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      span {
        color: #fff;
        font-size: 28px;
        font-weight: bold;
      }
    }

    .title {
      font-size: 20px;
      color: #333;
      margin: 0 0 8px 0;
      font-weight: 600;
    }

    .subtitle {
      font-size: 12px;
      color: #999;
      margin: 0;
    }
  }

  .login-form {
    width: 100%;

    .custom-input {
      margin-bottom: 20px;
      
      /deep/ .el-input__inner {
        height: 44px;
        border-radius: 8px;
        background-color: #f9f9f9;
        border-color: #eee;
      }
      
      /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #f9f9f9;
        color: #666;
      }
    }

    .remember-box {
      margin-bottom: 20px;
      /deep/ .el-checkbox__label {
        color: #666;
        font-size: 13px;
      }
    }

    .login-btn {
      width: 100%;
      height: 44px;
      border-radius: 8px;
      background-color: #3b82f6;
      border-color: #3b82f6;
      font-size: 16px;
      letter-spacing: 2px;
    }
  }

  .login-footer {
    position: absolute;
    bottom: 30px;
    text-align: center;
    font-size: 11px;
    color: #aaa;
    line-height: 1.6;
  }
}

/* ================= 主页样式 ================= */
.main-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f4f6f8;

  /* 顶部导航 */
  .header {
    height: 56px;
    background-color: #3b82f6;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    flex-shrink: 0;

    .header-left {
      display: flex;
      align-items: center;

      i {
        font-size: 20px;
        margin-right: 10px;
      }

      .header-title {
        display: flex;
        flex-direction: column;

        span:first-child {
          font-size: 16px;
          font-weight: 500;
        }

        .sub-title {
          font-size: 10px;
          opacity: 0.8;
          margin-top: 2px;
        }
      }
    }

    .header-right {
      font-size: 13px;
      opacity: 0.9;
      cursor: pointer;
    }
  }

  /* 滚动内容区 */
  .scroll-content {
    flex: 1;
    overflow-y: auto;
    padding: 12px 12px 70px 12px; /* 底部留出按钮的空间 */

    /* 四宫格菜单 */
    .menu-grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 12px;

      .menu-card {
        width: calc(50% - 6px);
        background-color: #ffffff;
        border-radius: 10px;
        padding: 12px;
        box-sizing: border-box;
        margin-bottom: 12px;
        box-shadow: 0 2px 6px rgba(0,0,0,0.02);

        .card-title {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin-bottom: 10px;
          padding-bottom: 8px;
          border-bottom: 1px solid #f0f0f0;

          i {
            margin-right: 6px;
            font-size: 16px;
          }
        }

        .card-list {
          .list-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            margin-bottom: 8px;
            
            &:last-child {
              margin-bottom: 0;
            }

            span:first-child {
              color: #333;
            }

            .desc {
              color: #999;
              font-size: 11px;
            }
          }
        }
      }
    }

    /* 统计条 */
    .stats-bar {
      background-color: #ffffff;
      border-radius: 10px;
      display: flex;
      padding: 15px 0;
      margin-bottom: 12px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.02);

      .stat-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-right: 1px solid #f0f0f0;

        &:last-child {
          border-right: none;
        }

        .num {
          font-size: 18px;
          font-weight: bold;
          color: #333;
          margin-bottom: 4px;
        }

        .label {
          font-size: 11px;
          color: #999;
        }
      }
    }

    /* 今日动态 */
    .dynamic-card {
      background-color: #ffffff;
      border-radius: 10px;
      padding: 12px;
      margin-bottom: 12px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.02);

      .dynamic-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }

        .sort {
          font-size: 11px;
          color: #999;
        }
      }

      .dynamic-list {
        .dynamic-item {
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-bottom: 10px;
          color: #666;

          &:last-child {
            margin-bottom: 0;
          }

          .time {
            width: 45px;
            color: #999;
          }

          .action {
            width: 40px;
            color: #666;
          }

          .name {
            flex: 1;
            color: #333;
          }

          .qty {
            font-weight: bold;
            &.in {
              color: #409EFF;
            }
            &.out {
              color: #67C23A;
            }
          }
        }
      }
    }

    /* 提示框 */
    .tips-box {
      background-color: #e6f1fc;
      color: #409eff;
      font-size: 12px;
      padding: 10px;
      border-radius: 6px;
      line-height: 1.5;
    }
  }

  /* 底部固定按钮 */
  .bottom-actions {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
    /* 适配iPhone底部安全区 */
    padding-bottom: calc(10px + constant(safe-area-inset-bottom));
    padding-bottom: calc(10px + env(safe-area-inset-bottom));

    .btn {
      flex: 1;
      height: 44px;
      border: none;
      border-radius: 6px;
      font-size: 15px;
      color: #fff;
      outline: none;
      cursor: pointer;

      &.btn-blue {
        background-color: #3b82f6;
        margin-right: 10px;
      }

      &.btn-green {
        background-color: #10b981;
      }
    }
  }
}
</style>